export default __webpack_public_path__ + "static/media/7aa89187907cbf47791e4208bcffa393.svg";